const categoryForSv = '追劇娛樂'
// 導引頁第五步的內容
const purposeContent = {
  purpose1: {
    si: '主要運用 <b>SuperImpact - 最大版面</b> 的格式組合，以震撼有感的廣告曝光創造過目不忘的上市氣勢',
    sv: `搭配運用<b>SuperView - ${categoryForSv}</b>，放送於各大影劇串流平台，確保影音完整溝通，強化上市記憶度`,
    line: '搭配運用 <b>LINE Today</b> 選用大版面的Mobile In-Read Transformer，在消費者黏著度極高的通訊平台上極大化觸及，加速滲透目標受眾',
    formatLinkText: '(點擊展開 最大版面 全格式選擇)',
    formatType: '最大版面'
  },
  purpose2: {
    si: '主要運用 <b>SuperImpact  - 首屏曝光</b> 的格式組合，首屏曝光第一時間抓住眼球，在競爭激烈的宣傳檔期突破重圍，建立深刻的廣告印象',
    line: '搭配運用 <b>LINE Today</b> 選用進場轉動吸睛的Mobile In-Read Transformer，在消費者黏著度極高的通訊平台上再次吸引消費者目光，加強滲透目標受眾',
    formatLinkText: '(點擊展開 首屏曝光 全格式選擇)',
    formatType: '首屏曝光'
  },
  purpose3: {
    si: '主要運用 <b>SuperImpact  - 原生大版面</b> 的格式組合，創造最低干擾的廣告體驗，並且指定受眾活躍的新聞及專業媒體，確保品牌在優質的媒體環境曝光，提升品牌好感度',
    sv: `搭配運用 <b>SuperView - ${categoryForSv}</b>，確保品牌於優質內容的影劇串流平台完整溝通廣告影音，加強烘托品牌形象高度`
    // 目的三沒有要展開的格式
  },
  purpose4: {
    si: '主要運用 <b>SuperImpact  - 產品聚焦</b> 的格式組合，運用格式特性有效突顯產品特色並持續吸睛，確保廣告重點訊息被看見，並且以全手機裝置將廣告直送網海各個角落，快速覆蓋目標受眾建立記憶度，鞏固品牌基本聲量'
    // 目的四的產品聚焦也只有一個格式，就不需要展蚈
  },
  purpose5: {
    si: '主要運用 <b>SuperImpact  - 邀請互動</b> 的格式組合，運用可乘載更多訊息的廣告格式，並藉由桌機與手機不同的使用習慣，創造直覺式的互動體驗，讓消費者在不知不覺中與廣告產生互動，並深入了解多重產品資訊',
    formatLinkText: '(點擊展開 邀請互動 全格式選擇)',
    formatType: '邀請互動'
  },
  purpose6: {
    si: '主要運用 <b>SuperImpact  - 邀請互動</b> 的格式組合，在桌機大螢屏展演精采品牌故事，透過格式上的互動機制，引起好奇心；在手機版面則將觀影主導權交還至消費者手中，自主回放重點訊息；跨螢屏邀請互動，建立品牌情感連結',
    formatLinkText: '(點擊展開 邀請互動 全格式選擇)',
    formatType: '邀請互動'
  }
}
const getAdTypeImg = (title) => {
  let iconName
  switch (title) {
    case 'In-Page':
    case 'Desktop In-Page':
      iconName = 'In-page.svg'
      break
    case 'In-Read':
    case 'Desktop In-Read':
      iconName = 'IR.svg'
      break
    case 'In-Read Showroom':
    case 'Desktop In-Read Showroom':
      iconName = 'IR showroom.svg'
      break
    case 'Mobile In-Read':
      iconName = 'MIRI.svg'
      break
    case 'Mobile In-Read Transformer':
      iconName = 'MIRT.svg'
      break
    case 'Mobile In-Read Instant':
      iconName = 'MIRI.svg'
      break
    case 'Mobile In-Read 橫互動':
      iconName = '橫互動.svg'
      break
    case 'Mobile In-Read 幀互動':
      iconName = '幀互動.svg'
      break
    case 'Mobile In-Read Scroller':
      iconName = 'MIRS.svg'
      break
    case 'Mobile In-Bottom':
      iconName = 'MIB動畫.svg'
      break
    case 'Mobile In-Read Skirt+':
      iconName = 'MIR SKIRT+.svg'
      break
    case 'Mobile In-Read Story':
      iconName = 'MIR Story.svg'
      break
  }

  return iconName ? require(`@/assets/images/ad_format/${iconName}`) : ''
}
const adFormatUrl = {
  'Desktop In-Page': 'https://demo.onead.com.tw/ov_player/preview/47013/950/390',
  'Desktop In-Read': 'https://creative.onead.com.tw/api/v1/packs/3663/preview?pid=1176245',
  'Desktop In-Read Story': 'https://creative.onead.com.tw/api/v1/packs/2353/preview',
  'Desktop In-Read Showcase': 'https://creative.onead.com.tw/api/v1/packs/2546/preview',
  'Mobile In-Read Transformer': 'https://creative.onead.com.tw/api/v1/packs/5369/preview',
  'Mobile In-Read Scroller': 'http://bit.ly/2rPHeTt',
  'Mobile In-Read Instant': 'https://creative.onead.com.tw/api/v1/packs/7767/preview?pid=1353204',
  'Mobile In-Read 橫互動': 'http://bit.ly/2WgA0kX',
  'Mobile In-Read 幀互動': 'http://bit.ly/2I7MxnB',
  'Mobile In-Read': 'https://creative.onead.com.tw/api/v1/packs/6756/preview?pid=1307505',
  'Mobile In-Read Skirt+': 'https://creative.onead.com.tw/api/v1/packs/7506/preview?pid=1338800',
  'Mobile In-Bottom': 'http://bit.ly/31l2HS6'
}
const recommendAdFormatTypes = {
  purpose1: [
    {
      title: 'Mobile In-Read Transformer',
      description: '露出於行動裝置文章中，當進入可視範圍時，吸睛動態上下展開。',
      links: [{
        name: '',
        link: adFormatUrl['Mobile In-Read Transformer']
      }]
    },
    {
      title: 'Desktop In-Page',
      description: '以超大置頂尺寸於桌機文章頁標題上方自動展開播放。',
      links: [{
        name: '',
        link: adFormatUrl['Desktop In-Page']
      }]
    }
  ],
  purpose2: [
    {
      title: 'Mobile In-Bottom',
      description: '行動裝置首屏Banner置底露出，滑動頁面觸發轉出影片與Banner。',
      links: [{
        name: '',
        link: adFormatUrl['Mobile In-Bottom']
      }]
    },
    {
      title: 'Desktop In-Page',
      description: '以超大置頂尺寸於桌機文章頁標題上方自動展開播放。',
      links: [{
        name: '',
        link: adFormatUrl['Desktop In-Page']
      }]
    }
  ],
  purpose3: [
    {
      title: 'Mobile In-Read Scroller',
      description: '露出於行動裝置文章中，滑動文章，揭開背景，影片於後層自動播放。',
      links: [{
        name: '',
        link: adFormatUrl['Mobile In-Read Scroller']
      }]
    },
    {
      title: 'Desktop In-Read',
      description: '露出於桌機文章中，當進入可視範圍時，影片自動播放。',
      links: [{
        name: '',
        link: adFormatUrl['Desktop In-Read']
      }]
    }
  ],
  purpose4: [
    {
      title: 'Mobile In-Read Skirt+',
      description: '出現於文章中間，右下角Banner破格區塊強調重點，當到可視範圍時動態吸睛。',
      links: [{
        name: '',
        link: adFormatUrl['Mobile In-Read Skirt+']
      }]
    }
  ],
  purpose5: [
    {
      title: 'Mobile In-Read 橫互動',
      description: '露出於手機裝置文章中，使用者在滑動文章的同時即會連動觸發素材左右滑移。',
      links: [{
        name: '',
        link: adFormatUrl['Mobile In-Read 橫互動']
      }]
    },
    {
      title: 'Desktop In-Read Showroom',
      description: '影片搭配左右滑動之多圖文橫幅廣告，進入桌機螢幕的可視範圍自動播放廣告。',
      links: [
        {
          name: 'In-Read Story',
          link: adFormatUrl['Desktop In-Read Story']
        },
        {
          name: 'In-Read Showcase',
          link: adFormatUrl['Desktop In-Read Showcase']
        }
      ]
    }
  ],
  purpose6: [
    {
      title: 'Mobile In-Read 幀互動',
      description: '露出於手機裝置文章中，使用者上下滑動文章觸發素材逐格切換。',
      links: [{
        name: '',
        link: adFormatUrl['Mobile In-Read 幀互動']
      }]
    },
    {
      title: 'Desktop In-Read Showroom',
      description: '影片搭配左右滑動之多圖文橫幅廣告，進入桌機螢幕的可視範圍自動播放廣告。',
      links: [
        {
          name: 'In-Read Story',
          link: adFormatUrl['Desktop In-Read Story']
        },
        {
          name: 'In-Read Showcase',
          link: adFormatUrl['Desktop In-Read Showcase']
        }
      ]
    }
  ]
}
export {
  purposeContent,
  getAdTypeImg,
  recommendAdFormatTypes,
  categoryForSv
}
